(() => {
  if (window.zokaCartFeedbackReady) return;
  window.zokaCartFeedbackReady = true;
  let timer;
  document.addEventListener('cart:update', (event) => {
    const detail = event.detail;
    if (detail?.data?.didError || detail?.cartData?.status >= 400) return;
    let count;
    for (const html of Object.values(detail?.cartData?.sections || {})) {
      if (typeof html !== 'string') continue;
      const cart = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="hdt-cart"][data-count]');
      if (cart) {
        count = Number(cart.dataset.count);
        break;
      }
    }
    if (!Number.isInteger(count)) count = detail?.cartData?.item_count;
    if (!Number.isInteger(count) || count < 0) return;
    queueMicrotask(() => {
      document.querySelectorAll('hdt-cart-count').forEach((badge) => {
        badge.textContent = String(count);
        badge.setAttribute('aria-live', 'polite');
        badge.setAttribute('aria-atomic', 'true');
      });
    });
  });
  document.addEventListener('cart:update', (event) => {
    const detail = event.detail;
    if (detail?.source !== 'product-form-component') {
      document.querySelectorAll('[data-zoka-cart-feedback]').forEach((element) => { element.hidden = true; });
      return;
    }
    if (detail.data?.didError || detail.cartData?.status >= 400) return;
    const added = detail.cartData?.items?.[0] || detail.cartData;
    const name = added?.product_title || added?.title || '';
    const variant = added?.variant_title;
    const description = [name, variant && variant !== 'Default Title' ? variant : ''].filter(Boolean).join(' · ');
    clearTimeout(timer);
    document.querySelectorAll('[data-zoka-cart-feedback]').forEach((element) => {
      element.querySelector('[data-zoka-cart-feedback-detail]').textContent = description;
      element.hidden = false;
    });
    timer = setTimeout(() => {
      document.querySelectorAll('.zoka-cart-feedback--toast').forEach((element) => { element.hidden = true; });
    }, 6500);
  });
  document.addEventListener('dialog:closing', () => {
    if (!document.querySelector('#CartDrawer[open]')) return;
    document.querySelectorAll('.zoka-cart-feedback--inline').forEach((element) => { element.hidden = true; });
  }, true);
})();
